export default __webpack_public_path__ + "static/media/copy-button.3d9319a3.svg";